import { handleActions } from '@mendeley-internal/lib-js-redux-actions';
import { login } from '../actions/session';
import { getMyProfile } from '../actions/profile';

const initialState = {
  isAuthenticated: false,
  user: null
};
export default handleActions({
  [login]: state => ({
    ...state,
    isAuthenticated: true
  }),
  [getMyProfile]: {
    next(state, { payload: { id } }) {
      return {
        ...state,
        user: id
      };
    },
    throw(state) {
      return {
        ...state,
      };
    }
  }
}, initialState);



// WEBPACK FOOTER //
// ./src/universal/ui/reducers/session.js